import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { StylishNewToggleButtonGroup } from 'components/DesignSystems/New/StylishNewToggleButtonGroup';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useFetchIncidentWorkspaceTeamStatus } from '../../../hooks/useFetchIncidentWorkspaceTeamStatus';
import { RosterActionsProps, RosterViewMode } from './types';
import IncidentNewSeatDialog from '../IncidentNewSeatDialog';

const RosterActions = ({
  isDraft = false,
  viewMode,
  onViewModeChange,
}: RosterActionsProps) => {
  const { data: teamsStatus } = useFetchIncidentWorkspaceTeamStatus();
  const [isNewSeatDialogOpen, setIsNewSeatDialogOpen] = useState(false);

  const onClickAddIncidentSeatButton = () => {
    if (teamsStatus === 'inprogress') {
      toast.success(
        'Creating team site is in progress. Please check back later.',
        {
          autoClose: 2000,
        }
      );
      return;
    }
    setIsNewSeatDialogOpen(true);
  };

  return (
    <>
      {/* Main Actions */}
      <div className="d-md-flex align-items-center mb-3">
        <h4 className="m-0">
          {isDraft ? '[DRAFT] - ' : ''}Incident Seat Roster
        </h4>
        {onViewModeChange && (
          <div className="ms-md-3 mt-2 mt-md-0">
            <StylishNewToggleButtonGroup
              size="sml"
              data={[
                { label: 'Org Chart View', value: 'orgchart' },
                { label: 'Table View', value: 'table' },
              ]}
              selected={viewMode ?? 'orgchart'}
              onChange={(value: string) =>
                onViewModeChange(value as RosterViewMode)
              }
            />
          </div>
        )}
        {/* TODO: Apply when permissions ready for front-end
        hasPermission(reduxValidateRBACPermissionForActionResult, 'incident:member:add') && ( */}
        <div className="ms-auto text-md-end">
          <StylishNewButton
            className="button--secondary ms-auto mt-2 mt-md-0 w-100 w-md-auto ms-0 ms-md-3"
            onClick={onClickAddIncidentSeatButton}
          >
            Add{isDraft ? ' (Draft)' : ''} Incident Seat
          </StylishNewButton>
        </div>
        {/* ) */}
      </div>

      {isNewSeatDialogOpen && (
        <>
          <IncidentNewSeatDialog
            show={true}
            onClose={() => setIsNewSeatDialogOpen(false)}
          />
        </>
      )}
    </>
  );
};

export default RosterActions;
